export default function About() {
  return (
    <section id="about" className="relative py-24 lg:py-32 bg-stone-50 overflow-hidden">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-teal-600/5 transform skew-x-12 translate-x-1/4"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-3 gap-12 items-center">
          <div className="lg:col-span-2">
            <p className="text-xs font-bold text-teal-600 uppercase tracking-widest mb-4">About KVADRUM</p>
            
            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              Building Trust Through<br />
              Transparent Technology
            </h2>

            <div className="space-y-6 text-lg text-gray-600 leading-relaxed max-w-2xl">
              <p>
                At KVADRUM, we believe that digital privacy is a fundamental right, not a luxury. Founded with a mission to make enterprise-grade security accessible to everyone, we've built a VPN solution that combines cutting-edge technology with user-friendly design.
              </p>
              
              <p>
                Our approach is simple: no compromises on security, no logs of your activity, and complete transparency in how we operate. We use military-grade encryption protocols and maintain a strict zero-knowledge architecture, ensuring that your data remains yours alone.
              </p>
              
              <p>
                Based in Croatia, we're committed to protecting users worldwide. Every feature we develop, every server we deploy, and every policy we implement is guided by one principle: your privacy comes first, always.
              </p>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="bg-gradient-to-br from-teal-600 to-emerald-600 rounded-3xl p-10 shadow-2xl text-white">
              <div className="text-center">
                <div className="text-2xl font-bold mb-2">Lovran, Croatia</div>
                <div className="text-base opacity-90">European Privacy Standards</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
